"use client";

import { useEffect } from "react";

import { useCommandPaletteStore } from "@/shared/lib/use-command-palette-store";
import { useToolWheelStore } from "@/shared/lib/use-tool-wheel-store";

export const CommandPaletteHotkeys = () => {
  const toggle = useCommandPaletteStore((s) => s.toggle);
  const toggleToolWheel = useToolWheelStore((s) => s.toggle);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target) {
        const tag = target.tagName;
        const isEditable =
          tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable;
        if (isEditable) return;
      }

      // KAN-867: колесо тулзов — Ctrl+Shift+K. По e.code, а не e.key: в русской
      // раскладке e.key даст «Л». В Firefox это сочетание забирает веб-консоль и
      // до страницы оно не доходит — там вход только кнопкой (см. ToolWheelLauncher).
      if (
        e.ctrlKey &&
        e.shiftKey &&
        !e.metaKey &&
        !e.altKey &&
        e.code === "KeyK"
      ) {
        e.preventDefault();
        toggleToolWheel();
        return;
      }

      // Только Ctrl (без Meta/Shift)
      if (!e.ctrlKey || e.shiftKey || e.metaKey) return;

      // EN: Ctrl+/, RU: Ctrl+.
      const isCtrlSlashEN = e.code === "Slash";
      const isCtrlDotRU = e.code === "Period";

      if (isCtrlSlashEN || isCtrlDotRU) {
        e.preventDefault();
        toggle();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggle, toggleToolWheel]);

  return null; // This component does not render anything
};
